import {Button, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import {Edit} from "@mui/icons-material";
import useAlert from "../../../../../../use/useAlert";
import {useRef} from "react";
import isNull from "../../../../../../mixin/isNull";

const ERROR_NAME_REQUIRED = "Nom requis";
const ERROR_PRICING_REQUIRED = "Prix requis";
const ERROR_QUANTITY_REQUIRED = "Quantité requise";

export default function ({quotationItem, onSubmit}) {
    const alert = useAlert();
    const nameInput = useRef();
    const pricingInput = useRef();
    const quantityInput = useRef();

    const handleSubmit = () => {
        if (!nameInput.current.value) {
            alert.warning(ERROR_NAME_REQUIRED);
            return;
        }

        if (!pricingInput.current.value) {
            alert.warning(ERROR_PRICING_REQUIRED);
            return;
        }

        if (!quantityInput.current.value) {
            alert.warning(ERROR_QUANTITY_REQUIRED);
            return;
        }

        onSubmit({
            name: nameInput.current.value,
            pricing: Math.round(parseFloat(pricingInput.current.value) * 100),
            quantity: parseInt(quantityInput.current.value, 10),
            standardized_item_id: quotationItem.standardized_item_id
        });
    }

    const isStandardized = !isNull(quotationItem.standardized_item_id);

    return (
        <>
            <div>
                <TextField
                    inputRef={nameInput}
                    fullWidth
                    autoFocus={!isStandardized}
                    variant={"standard"}
                    label={"Désignation"}
                    defaultValue={quotationItem.name}
                    disabled={isStandardized}
                    required
                    data-test="insurance-input-update-name"
                />
            </div>
            <Box mt={2}>
                <TextField
                    inputRef={pricingInput}
                    fullWidth
                    variant={"standard"}
                    label={"Prix HT (€)"}
                    type={"number"}
                    inputProps={{step: "0.01", min: "0"}}
                    required
                    defaultValue={quotationItem.pricing / 100}
                    disabled={isStandardized}
                    data-test="insurance-input-update-pricing"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={quantityInput}
                    fullWidth
                    autoFocus={isStandardized}
                    variant={"standard"}
                    label={"Quantité"}
                    type={"number"}
                    inputProps={{min: "1", step: "1"}}
                    defaultValue={quotationItem.quantity}
                    required
                    data-test="insurance-input-update-quantity"
                />
            </Box>
            <Box mt={2} display="flex" justifyContent="center">
                <Button
                    startIcon={<Edit/>}
                    variant="contained"
                    size="small"
                    fullWidth
                    onClick={handleSubmit}
                    data-test="insurance-button-update-quotation-item"
                >
                    Modifier
                </Button>
            </Box>
        </>
    );
}
